import React, { useState } from 'react';
import {
    FaCalculator,
    FaFileAlt,
    FaMoneyBillWave,
    FaCheckCircle,
    FaDownload,
    FaQuestionCircle,
    FaLandmark,
    FaMapMarkedAlt,
    FaClipboardList,
    FaClock,
    FaCalendarCheck,
    FaPhone,
    FaWhatsapp,
    FaSearch,
    FaInfoCircle,
    FaBuilding,
    FaUser
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const RetribusiIPT = () => {
    const [activeTab, setActiveTab] = useState('kalkulator');
    const [showForm, setShowForm] = useState(false);
    const [kalkulatorData, setKalkulatorData] = useState({
        luasTanah: '',
        zona: 'pusat',
        peruntukan: 'komersial',
        jangkaWaktu: '1'
    });
    const [hasilKalkulasi, setHasilKalkulasi] = useState(null);

    const tabs = [
        { id: 'kalkulator', label: 'Kalkulator Retribusi', icon: FaCalculator },
        { id: 'ketentuan', label: 'Ketentuan', icon: FaClipboardList },
        { id: 'prosedur', label: 'Prosedur Pembayaran', icon: FaMoneyBillWave },
        { id: 'pembayaran', label: 'Pembayaran Online', icon: FaLandmark },
    ];

    const tarifZona = {
        pusat: { nama: 'Pusat Kota', tarif: 50000, deskripsi: 'Jl. Jend. Sudirman, Alun-alun, Pecinan' },
        menengah: { nama: 'Zona Menengah', tarif: 35000, deskripsi: 'Kawasan perumahan dan bisnis menengah' },
        pinggiran: { nama: 'Zona Pinggiran', tarif: 20000, deskripsi: 'Kawasan pinggiran dan pemukiman' }
    };

    const tarifPeruntukan = {
        komersial: { nama: 'Komersial', koefisien: 1.5, deskripsi: 'Ruko, toko, restoran, hotel' },
        industri: { nama: 'Industri', koefisien: 1.3, deskripsi: 'Pabrik, gudang, workshop' },
        sosial: { nama: 'Sosial', koefisien: 0.5, deskripsi: 'Sekolah, rumah ibadah, klinik' },
        pertanian: { nama: 'Pertanian', koefisien: 0.3, deskripsi: 'Sawah, ladang, perkebunan' }
    };

    const hitungRetribusi = () => {
        const luas = parseFloat(kalkulatorData.luasTanah) || 0;
        const tarifDasar = tarifZona[kalkulatorData.zona].tarif;
        const koefisien = tarifPeruntukan[kalkulatorData.peruntukan].koefisien;
        const tahun = parseInt(kalkulatorData.jangkaWaktu);

        const retribusiPerTahun = luas * tarifDasar * koefisien;
        const totalRetribusi = retribusiPerTahun * tahun;
        const biayaAdmin = 50000;
        const biayaSurvey = luas > 100 ? 150000 : 100000;
        const grandTotal = totalRetribusi + biayaAdmin + biayaSurvey;

        setHasilKalkulasi({
            luas,
            tarifDasar,
            koefisien,
            retribusiPerTahun,
            totalRetribusi,
            biayaAdmin,
            biayaSurvey,
            grandTotal,
            tahun,
            zona: tarifZona[kalkulatorData.zona].nama,
            peruntukan: tarifPeruntukan[kalkulatorData.peruntukan].nama
        });
    };

    const ketentuanList = [
        {
            judul: "Dasar Hukum",
            icon: FaFileAlt,
            items: [
                "Peraturan Daerah Kota Magelang No. 5 Tahun 2023 tentang Retribusi Daerah",
                "Peraturan Walikota Magelang No. 12 Tahun 2023 tentang Petunjuk Teknis Pemungutan Retribusi",
                "Keputusan Kepala BPKAD No. 188/2024 tentang Standar Operasional Prosedur"
            ]
        },
        {
            judul: "Subjek Retribusi",
            icon: FaUser,
            items: [
                "Perseorangan (WNI/WNA yang memiliki KTP/identitas resmi)",
                "Badan Usaha (PT, CV, Koperasi, Yayasan)",
                "Instansi Pemerintah/Swasta",
                "Kelompok Masyarakat yang memiliki legalitas"
            ]
        },
        {
            judul: "Objek Retribusi",
            icon: FaBuilding,
            items: [
                "Tanah milik Pemerintah Kota Magelang",
                "Tanah fasilitas umum yang dikelola Pemkot",
                "Tanah aset daerah yang belum dimanfaatkan",
                "Lahan kosong di bawah pengelolaan BPKAD"
            ]
        }
    ];

    const prosedurPembayaran = [
        {
            step: 1,
            title: "Dapatkan SKRD",
            description: "Ambil Surat Ketetapan Retribusi Daerah (SKRD) di kantor BPKAD setelah permohonan disetujui",
            icon: FaFileAlt,
            durasi: "1 hari kerja"
        },
        {
            step: 2,
            title: "Verifikasi Tagihan",
            description: "Periksa rincian tagihan retribusi yang tertera di SKRD, pastikan sesuai dengan perhitungan",
            icon: FaClipboardList,
            durasi: "Langsung"
        },
        {
            step: 3,
            title: "Lakukan Pembayaran",
            description: "Bayar melalui Bank Jateng, BPD, atau channel pembayaran online yang tersedia",
            icon: FaMoneyBillWave,
            durasi: "1 hari kerja"
        },
        {
            step: 4,
            title: "Verifikasi Pembayaran",
            description: "Konfirmasi pembayaran ke petugas BPKAD dengan menunjukkan bukti pembayaran",
            icon: FaCheckCircle,
            durasi: "1-2 jam"
        },
        {
            step: 5,
            title: "Terima Bukti Lunas",
            description: "Dapatkan Surat Keterangan Lunas dan Izin Pemakaian Tanah yang sudah disahkan",
            icon: FaCalendarCheck,
            durasi: "1 hari kerja"
        }
    ];

    const metodePembayaran = [
        { bank: "Bank Jateng", kode: "001", rekening: "1-001-23456-7", logo: "🏦" },
        { bank: "BNI", kode: "009", rekening: "0123456789", logo: "🏦" },
        { bank: "BRI", kode: "002", rekening: "0123-01-000001-50-1", logo: "🏦" },
        { bank: "QRIS", kode: "QR", rekening: "Scan QR Code", logo: "📱" },
    ];

    const faqList = [
        {
            question: "Bagaimana cara menghitung retribusi IPT?",
            answer: "Retribusi dihitung berdasarkan rumus: Luas Tanah × Tarif Dasar Zona × Koefisien Peruntukan × Jangka Waktu. Gunakan kalkulator retribusi di halaman ini untuk memudahkan perhitungan."
        },
        {
            question: "Kapan retribusi harus dibayarkan?",
            answer: "Retribusi harus dibayarkan setelah SKRD diterbitkan dan sebelum izin diberikan. Pembayaran dapat dilakukan paling lambat 7 hari kerja setelah SKRD terbit."
        },
        {
            question: "Apakah retribusi bisa dicicil?",
            answer: "Untuk nilai retribusi di atas Rp 10.000.000, dapat mengajukan permohonan pembayaran bertahap maksimal 3 kali angsuran dengan persetujuan Kepala BPKAD."
        },
        {
            question: "Bagaimana jika telat membayar?",
            answer: "Keterlambatan pembayaran dikenakan denda 2% per bulan dari nilai retribusi yang tertunggak."
        },
        {
            question: "Apakah retribusi bisa dikembalikan?",
            answer: "Retribusi tidak dapat dikembalikan kecuali terdapat kesalahan administratif dari pihak BPKAD yang mengakibatkan kelebihan pembayaran."
        }
    ];

    return (
        <div className="container mx-auto px-4 py-12">
            {/* Header */}
            <div className="mb-8">
                <div className="flex items-center space-x-3 mb-4">
                    <FaMoneyBillWave className="text-4xl text-[#0D9488]" />
                    <h1 className="text-3xl md:text-4xl font-bold text-[#1E3A8A]">
                        Retribusi Izin Pemakaian Tanah (IPT)
                    </h1>
                </div>
                <p className="text-gray-600 text-lg">
                    Informasi dan layanan pembayaran retribusi pemakaian tanah aset Pemerintah Kota Magelang
                </p>
            </div>

            {/* Tab Navigation */}
            <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center px-6 py-3 text-sm font-medium transition-all duration-200 border-b-2 ${activeTab === tab.id
                                ? 'border-[#0D9488] text-[#0D9488] bg-[#0D9488]/5'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        <tab.icon className="mr-2" />
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div className="space-y-8">
                {/* Kalkulator Retribusi */}
                {activeTab === 'kalkulator' && (
                    <div>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            {/* Form Kalkulator */}
                            <div className="card-glass">
                                <h3 className="text-xl font-bold text-[#1E3A8A] mb-6 flex items-center">
                                    <FaCalculator className="mr-2 text-[#0D9488]" />
                                    Kalkulator Retribusi IPT
                                </h3>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Luas Tanah (m²) *
                                        </label>
                                        <div className="relative">
                                            <input
                                                type="number"
                                                value={kalkulatorData.luasTanah}
                                                onChange={(e) => setKalkulatorData({ ...kalkulatorData, luasTanah: e.target.value })}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                placeholder="Masukkan luas tanah"
                                            />
                                            <span className="absolute right-3 top-2 text-gray-400">m²</span>
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Zona Lokasi *
                                        </label>
                                        <select
                                            value={kalkulatorData.zona}
                                            onChange={(e) => setKalkulatorData({ ...kalkulatorData, zona: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            <option value="pusat">Pusat Kota (Rp 50.000/m²/tahun)</option>
                                            <option value="menengah">Zona Menengah (Rp 35.000/m²/tahun)</option>
                                            <option value="pinggiran">Zona Pinggiran (Rp 20.000/m²/tahun)</option>
                                        </select>
                                        <p className="text-xs text-gray-500 mt-1">{tarifZona[kalkulatorData.zona].deskripsi}</p>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Peruntukan *
                                        </label>
                                        <select
                                            value={kalkulatorData.peruntukan}
                                            onChange={(e) => setKalkulatorData({ ...kalkulatorData, peruntukan: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            <option value="komersial">Komersial (Koef. 1.5)</option>
                                            <option value="industri">Industri (Koef. 1.3)</option>
                                            <option value="sosial">Sosial (Koef. 0.5)</option>
                                            <option value="pertanian">Pertanian (Koef. 0.3)</option>
                                        </select>
                                        <p className="text-xs text-gray-500 mt-1">{tarifPeruntukan[kalkulatorData.peruntukan].deskripsi}</p>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Jangka Waktu (Tahun) *
                                        </label>
                                        <select
                                            value={kalkulatorData.jangkaWaktu}
                                            onChange={(e) => setKalkulatorData({ ...kalkulatorData, jangkaWaktu: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            <option value="1">1 Tahun</option>
                                            <option value="2">2 Tahun</option>
                                            <option value="3">3 Tahun</option>
                                            <option value="5">5 Tahun</option>
                                        </select>
                                    </div>

                                    <button
                                        onClick={hitungRetribusi}
                                        className="btn-primary w-full flex items-center justify-center"
                                    >
                                        <FaCalculator className="mr-2" />
                                        Hitung Retribusi
                                    </button>
                                </div>
                            </div>

                            {/* Hasil Kalkulasi */}
                            <div>
                                {hasilKalkulasi ? (
                                    <div className="card-glass">
                                        <h3 className="text-xl font-bold text-[#1E3A8A] mb-6">Hasil Kalkulasi</h3>

                                        <div className="space-y-4">
                                            <div className="bg-gray-50 p-4 rounded-lg">
                                                <h4 className="font-semibold text-[#1E3A8A] mb-3">Informasi Tanah</h4>
                                                <div className="grid grid-cols-2 gap-3 text-sm">
                                                    <div>
                                                        <span className="text-gray-600">Luas Tanah:</span>
                                                        <p className="font-semibold">{hasilKalkulasi.luas} m²</p>
                                                    </div>
                                                    <div>
                                                        <span className="text-gray-600">Zona:</span>
                                                        <p className="font-semibold">{hasilKalkulasi.zona}</p>
                                                    </div>
                                                    <div>
                                                        <span className="text-gray-600">Peruntukan:</span>
                                                        <p className="font-semibold">{hasilKalkulasi.peruntukan}</p>
                                                    </div>
                                                    <div>
                                                        <span className="text-gray-600">Jangka Waktu:</span>
                                                        <p className="font-semibold">{hasilKalkulasi.tahun} tahun</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="bg-green-50 p-4 rounded-lg">
                                                <h4 className="font-semibold text-green-800 mb-3">Rincian Biaya</h4>
                                                <div className="space-y-2 text-sm">
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Tarif Dasar Zona:</span>
                                                        <span>Rp {hasilKalkulasi.tarifDasar.toLocaleString()} /m²/tahun</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Koefisien Peruntukan:</span>
                                                        <span>{hasilKalkulasi.koefisien}x</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Retribusi per Tahun:</span>
                                                        <span>Rp {hasilKalkulasi.retribusiPerTahun.toLocaleString()}</span>
                                                    </div>
                                                    <div className="flex justify-between font-semibold">
                                                        <span>Total Retribusi ({hasilKalkulasi.tahun} tahun):</span>
                                                        <span>Rp {hasilKalkulasi.totalRetribusi.toLocaleString()}</span>
                                                    </div>
                                                    <hr className="border-green-200" />
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Biaya Administrasi:</span>
                                                        <span>Rp {hasilKalkulasi.biayaAdmin.toLocaleString()}</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Biaya Survey:</span>
                                                        <span>Rp {hasilKalkulasi.biayaSurvey.toLocaleString()}</span>
                                                    </div>
                                                    <hr className="border-green-200" />
                                                    <div className="flex justify-between text-lg font-bold text-green-800">
                                                        <span>Grand Total:</span>
                                                        <span>Rp {hasilKalkulasi.grandTotal.toLocaleString()}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="bg-yellow-50 p-4 rounded-lg">
                                                <p className="text-sm text-yellow-800 flex items-start">
                                                    <FaInfoCircle className="mr-2 mt-0.5 flex-shrink-0" />
                                                    Hasil kalkulasi ini adalah estimasi. Nilai pasti akan ditetapkan dalam SKRD oleh petugas BPKAD.
                                                </p>
                                            </div>

                                            <Link to="/layanan/ajukan-permohonan-ipt" className="btn-primary w-full inline-block text-center">
                                                <FaFileAlt className="mr-2 inline" />
                                                Ajukan Permohonan IPT
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card-glass h-full flex items-center justify-center">
                                        <div className="text-center text-gray-400">
                                            <FaCalculator className="text-6xl mx-auto mb-4" />
                                            <p className="text-lg">Masukkan data tanah dan klik "Hitung Retribusi"</p>
                                            <p className="text-sm mt-2">untuk melihat estimasi biaya retribusi</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Info Tarif */}
                        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
                            {Object.entries(tarifZona).map(([key, zona]) => (
                                <div key={key} className="card-glass text-center">
                                    <FaMapMarkedAlt className="text-3xl text-[#0D9488] mx-auto mb-3" />
                                    <h4 className="font-bold text-[#1E3A8A] mb-2">{zona.nama}</h4>
                                    <p className="text-2xl font-bold text-[#0D9488] mb-2">Rp {zona.tarif.toLocaleString()}</p>
                                    <p className="text-sm text-gray-500">per m² per tahun</p>
                                    <p className="text-xs text-gray-400 mt-2">{zona.deskripsi}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Ketentuan Tab */}
                {activeTab === 'ketentuan' && (
                    <div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                            {ketentuanList.map((ketentuan, index) => (
                                <div key={index} className="card-glass">
                                    <div className="flex items-center mb-4">
                                        <div className="w-12 h-12 bg-[#0D9488]/10 rounded-full flex items-center justify-center mr-3">
                                            <ketentuan.icon className="text-xl text-[#0D9488]" />
                                        </div>
                                        <h3 className="text-lg font-bold text-[#1E3A8A]">{ketentuan.judul}</h3>
                                    </div>
                                    <ul className="space-y-2">
                                        {ketentuan.items.map((item, idx) => (
                                            <li key={idx} className="flex items-start text-sm">
                                                <FaCheckCircle className="text-[#0D9488] mt-1 mr-2 flex-shrink-0" />
                                                <span className="text-gray-700">{item}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>

                        {/* Tabel Tarif Lengkap */}
                        <div className="card-glass">
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-4">Tabel Tarif Retribusi IPT</h3>
                            <div className="overflow-x-auto">
                                <table className="w-full">
                                    <thead>
                                        <tr className="bg-[#1E3A8A] text-white">
                                            <th className="px-4 py-3 text-left text-sm">Zona</th>
                                            <th className="px-4 py-3 text-left text-sm">Peruntukan</th>
                                            <th className="px-4 py-3 text-right text-sm">Tarif Dasar/m²/th</th>
                                            <th className="px-4 py-3 text-center text-sm">Koefisien</th>
                                            <th className="px-4 py-3 text-right text-sm">Tarif Final/m²/th</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(tarifZona).map(([keyZona, zona]) => (
                                            Object.entries(tarifPeruntukan).map(([keyGuna, guna]) => (
                                                <tr key={`${keyZona}-${keyGuna}`} className="border-b hover:bg-gray-50">
                                                    {keyGuna === Object.keys(tarifPeruntukan)[0] && (
                                                        <td rowSpan={Object.keys(tarifPeruntukan).length} className="px-4 py-3 font-semibold text-[#1E3A8A]">
                                                            {zona.nama}
                                                        </td>
                                                    )}
                                                    <td className="px-4 py-3 text-sm text-gray-700">{guna.nama}</td>
                                                    <td className="px-4 py-3 text-sm text-right">Rp {zona.tarif.toLocaleString()}</td>
                                                    <td className="px-4 py-3 text-sm text-center">{guna.koefisien}x</td>
                                                    <td className="px-4 py-3 text-sm text-right font-semibold">
                                                        Rp {(zona.tarif * guna.koefisien).toLocaleString()}
                                                    </td>
                                                </tr>
                                            ))
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}

                {/* Prosedur Pembayaran Tab */}
                {activeTab === 'prosedur' && (
                    <div>
                        <div className="relative">
                            {/* Timeline Line */}
                            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-[#0D9488]/20 hidden md:block"></div>

                            <div className="space-y-8">
                                {prosedurPembayaran.map((prosedur, index) => (
                                    <div key={index} className="relative flex items-start">
                                        {/* Step Number */}
                                        <div className="flex-shrink-0 w-16 h-16 bg-[#0D9488] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg z-10">
                                            {prosedur.step}
                                        </div>

                                        {/* Content */}
                                        <div className="ml-6 card-glass flex-1">
                                            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3">
                                                <h3 className="text-xl font-bold text-[#1E3A8A] flex items-center">
                                                    <prosedur.icon className="mr-2 text-[#0D9488]" />
                                                    {prosedur.title}
                                                </h3>
                                                <span className="text-sm bg-[#0D9488]/10 text-[#0D9488] px-3 py-1 rounded-full font-medium mt-2 md:mt-0 inline-block w-fit">
                                                    <FaClock className="inline mr-1" />
                                                    {prosedur.durasi}
                                                </span>
                                            </div>
                                            <p className="text-gray-600">{prosedur.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* Pembayaran Online Tab */}
                {activeTab === 'pembayaran' && (
                    <div>
                        <div className="card-glass mb-8">
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-4">Metode Pembayaran</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {metodePembayaran.map((metode, index) => (
                                    <div key={index} className="flex items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                                        <span className="text-4xl mr-4">{metode.logo}</span>
                                        <div>
                                            <p className="font-semibold text-gray-800">{metode.bank}</p>
                                            <p className="text-sm text-gray-600">Kode Bank: {metode.kode}</p>
                                            <p className="text-sm text-gray-600">No. Rek: {metode.rekening}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Form Konfirmasi Pembayaran */}
                        <div className="card-glass">
                            <div className="flex justify-between items-center mb-6">
                                <h3 className="text-xl font-bold text-[#1E3A8A]">Konfirmasi Pembayaran</h3>
                                <button
                                    onClick={() => setShowForm(!showForm)}
                                    className="btn-primary"
                                >
                                    {showForm ? 'Tutup Form' : 'Konfirmasi Sekarang'}
                                </button>
                            </div>

                            {showForm && (
                                <form className="space-y-4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">No. SKRD *</label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                placeholder="Masukkan nomor SKRD"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Nama Pembayar *</label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                placeholder="Masukkan nama pembayar"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Tanggal Pembayaran *</label>
                                            <input
                                                type="date"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Jumlah Dibayar *</label>
                                            <input
                                                type="number"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                placeholder="Masukkan jumlah pembayaran"
                                            />
                                        </div>
                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Upload Bukti Pembayaran *</label>
                                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                                                <FaDownload className="mx-auto text-3xl text-gray-400 mb-2" />
                                                <p className="text-sm text-gray-500">
                                                    Upload bukti transfer/foto bukti pembayaran
                                                </p>
                                                <p className="text-xs text-gray-400 mt-1">
                                                    Format: JPG, PNG, PDF (Maks. 2MB)
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn-primary w-full">
                                        Kirim Konfirmasi
                                    </button>
                                </form>
                            )}
                        </div>

                        {/* Cek Status Pembayaran */}
                        <div className="mt-8 card-glass">
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-4 flex items-center">
                                <FaSearch className="mr-2 text-[#0D9488]" />
                                Cek Status Pembayaran
                            </h3>
                            <div className="flex gap-4">
                                <input
                                    type="text"
                                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                    placeholder="Masukkan No. SKRD atau NIK"
                                />
                                <button className="btn-primary">
                                    <FaSearch className="mr-2 inline" />
                                    Cek Status
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* FAQ Section */}
            <div className="mt-12">
                <h2 className="text-2xl font-bold text-[#1E3A8A] mb-6 flex items-center">
                    <FaQuestionCircle className="mr-2 text-[#0D9488]" />
                    Pertanyaan Umum (FAQ)
                </h2>
                <div className="space-y-4">
                    {faqList.map((faq, index) => (
                        <details key={index} className="card-glass group cursor-pointer">
                            <summary className="flex justify-between items-center list-none">
                                <span className="text-lg font-semibold text-[#1E3A8A]">{faq.question}</span>
                                <span className="text-[#0D9488] group-open:rotate-180 transition-transform text-xl">
                                    ▼
                                </span>
                            </summary>
                            <p className="mt-3 text-gray-600 pl-2 border-l-4 border-[#0D9488]">
                                {faq.answer}
                            </p>
                        </details>
                    ))}
                </div>
            </div>

            {/* Contact Section */}
            <div className="mt-12 card-glass bg-gradient-to-r from-[#1E3A8A] to-[#0D9488] text-white">
                <div className="text-center">
                    <h3 className="text-2xl font-bold mb-4">Butuh Bantuan Terkait Pembayaran?</h3>
                    <p className="mb-6">Tim kami siap membantu Anda dalam proses pembayaran retribusi IPT</p>
                    <div className="flex flex-col md:flex-row justify-center gap-4">
                        <button className="bg-white text-[#1E3A8A] px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors flex items-center justify-center">
                            <FaPhone className="mr-2" />
                            (0293) 123456
                        </button>
                        <button className="bg-green-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors flex items-center justify-center">
                            <FaWhatsapp className="mr-2" />
                            Chat WhatsApp
                        </button>
                    </div>
                    <p className="mt-4 text-sm opacity-80">
                        Jam operasional: Senin-Kamis 07.30-16.00 | Jumat 07.30-16.30
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RetribusiIPT;